import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, Mail, Clock } from 'lucide-react';

const AccessDeniedPage = ({ user = null }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-xl" data-testid="access-denied-page">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <Shield className="w-8 h-8 text-red-600" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">Access Pending Approval</CardTitle>
        </CardHeader>

        <CardContent className="space-y-6">
          {/* User Info */}
          {user && (
            <div className="bg-gray-50 rounded-lg p-4 text-center">
              {user.picture && (
                <img src={user.picture} alt={user.name} className="w-16 h-16 rounded-full mx-auto mb-3" />
              )}
              <p className="font-medium text-gray-900">{user.name}</p>
              <p className="text-sm text-gray-600">{user.email}</p>
            </div>
          )}

          {/* Status Message */}
          <div className="text-center space-y-3">
            <div className="flex items-center justify-center space-x-2 text-orange-600">
              <Clock className="w-5 h-5" />
              <span className="font-medium">Waiting for Admin Approval</span>
            </div>
            <p className="text-sm text-gray-600">
              Your account has been created successfully, but you need approval from the administrator to access this application.
            </p>
          </div>

          {/* Instructions */}
          <div className="bg-blue-50 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-blue-900 text-sm">What happens next?</h3>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• The administrator has been notified of your registration</li>
              <li>• They will review and approve your access request</li>
              <li>• You'll be able to login once approved</li>
              <li>• Check back later or contact the administrator</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="border-t pt-4">
            <div className="flex items-center justify-center space-x-2 text-gray-600">
              <Mail className="w-4 h-4" />
              <span className="text-sm">
                If you have questions, contact the administrator
              </span>
            </div>
          </div>

          {/* Note */}
          <div className="text-center">
            <p className="text-xs text-gray-500">
              This is a private research application with restricted access.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDeniedPage;
